import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
import { POST } from "./common/http";

export const GetHsnSacList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Master/HsnSacList?` + params, null);

export const GetStrengthUnitList = () =>
  GET_ENC(`${BASE_URL}/api/Master/GetStrengthUnitList?`, null);

export const GetPerVolumeUnitList = () =>
  GET_ENC(`${BASE_URL}/api/Master/GetPerVolumeUnitList?`, null);

export const GetPrintUnitList = (signal?: AbortSignal) =>
  GET_ENC(`${BASE_URL}/api/Master/GetPrintUnitList?`, null, signal);

export const GetPackagePerVolumeUnitList = () =>
  GET_ENC(`${BASE_URL}/api/Master/GetPackagePerVolumeUnitList?`, null);

export const GetPackageUnitList = (signal?: AbortSignal) =>
  GET_ENC(`${BASE_URL}/api/Master/GetPackageUnitList?`, null, signal);

export const GetFrequencyUnitList = (signal?: AbortSignal) =>
  GET_ENC(`${BASE_URL}/api/Master/GetFrequencyUnitList?`, null, signal);

export const GetPerIntervalUnitList = () =>
  GET_ENC(`${BASE_URL}/api/Master/GetPerIntervalUnitList?`, null);

export const GetTreatmentDurationUnitList = (signal?: AbortSignal) =>
  GET_ENC(`${BASE_URL}/api/Master/GetTreatmentDurationUnitList?`, null, signal);

export const GetCalculatedDose = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Master/GetCalculatedDose`, data);

export const GetFinancialYearList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Master/FinancialYearList?` + params, null);

export const UploadFile = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Master/UploadFile`, data, true);